import React from 'react';
import { useParams } from 'react-router-dom';
import CustomerModal from '../components/CustomerModal';
import PurchaseInvoiceCorrectionModal from '../components/PurchaseInvoiceCorrectionModal';
import {
  InvoiceHeader,
  InvoiceInfoPanel,
  InvoiceItemsTable,
  EditItemModal,
  MappingModal,
  usePurchaseInvoice
} from '../components/purchase';

const PurchaseInvoiceDetailsPage = () => {
  const { id } = useParams();
  const hook = usePurchaseInvoice(id);

  // ===== Loading / error / empty states =====

  if (hook.loading) {
    return (
      <div style={{ padding: '2rem', textAlign: 'center' }}>
        <div style={{ fontSize: '2rem', marginBottom: '1rem' }}>...</div>
        <div style={{ color: 'var(--text-muted)', fontSize: '12px' }}>Ladowanie szczegolow faktury...</div>
      </div>
    );
  }

  if (hook.error) {
    return (
      <div style={{ padding: '0.75rem', fontSize: '12px' }}>
        <div style={{
          padding: '0.5rem 0.75rem', backgroundColor: 'var(--danger-light)', color: 'var(--danger)',
          borderRadius: '4px', marginBottom: '0.75rem'
        }}>
          {hook.error}
        </div>
        <button
          onClick={() => hook.navigate('/purchase-invoices/list')}
          style={{
            padding: '0.35rem 0.75rem', fontSize: '11px', border: '1px solid var(--text-muted)',
            borderRadius: '4px', backgroundColor: 'var(--card-bg)', cursor: 'pointer'
          }}
        >
          Powrot do listy
        </button>
      </div>
    );
  }

  if (!hook.invoice) {
    return (
      <div style={{ padding: '0.75rem', fontSize: '12px' }}>
        <div style={{
          padding: '1rem', backgroundColor: 'var(--warning-light)', color: 'var(--warning)',
          borderRadius: '4px', textAlign: 'center'
        }}>
          Faktura nie zostala znaleziona
        </div>
      </div>
    );
  }

  // ===== Main render =====

  return (
    <div style={{ padding: '0.75rem', fontSize: '12px' }}>
      <InvoiceHeader
        invoice={hook.invoice}
        id={id}
        navigate={hook.navigate}
        canGeneratePZ={hook.canGeneratePZ}
        autoMappingLoading={hook.autoMappingLoading}
        onEdit={() => hook.navigate(`/purchase-invoices/${id}/edit`)}
        onCorrection={() => hook.setShowCorrectionModal(true)}
        onAutoMap={hook.autoMapInvoiceItems}
        onGeneratePZ={hook.generateWarehouseReceipt}
        onBack={() => hook.navigate('/purchase-invoices/list')}
      />

      <div style={{ maxWidth: '1400px', margin: '0 auto' }}>
        <InvoiceInfoPanel
          invoice={hook.invoice}
          showSupplierSearch={hook.showSupplierSearch}
          setShowSupplierSearch={hook.setShowSupplierSearch}
          supplierSearchQuery={hook.supplierSearchQuery}
          supplierSearchResults={hook.supplierSearchResults}
          supplierSearchLoading={hook.supplierSearchLoading}
          handleSupplierSearch={hook.handleSupplierSearch}
          selectSupplier={hook.selectSupplier}
          supplierSearchRef={hook.supplierSearchRef}
          supplierDropdownRef={hook.supplierDropdownRef}
          setShowAddSupplierModal={hook.setShowAddSupplierModal}
        />

        <InvoiceItemsTable
          invoice={hook.invoice}
          sortConfig={hook.sortConfig}
          handleSort={hook.handleSort}
          getSortedItems={hook.getSortedItems}
          selectedItems={hook.selectedItems}
          handleItemSelection={hook.handleItemSelection}
          handleSelectAllItems={hook.handleSelectAllItems}
          openMappingModal={hook.openMappingModal}
          openEditModal={hook.openEditModal}
          handleQuickNameUpdate={hook.handleQuickNameUpdate}
          editLocked={hook.isPzGenerated}
        />

        {/* Notes section */}
        {hook.invoice?.uwagi && (
          <div style={{
            backgroundColor: 'var(--card-bg)', border: '1px solid var(--border)',
            borderRadius: '0.375rem',
            boxShadow: '0 0.125rem 0.25rem rgba(0, 0, 0, 0.075)',
            marginTop: '1rem'
          }}>
            <div style={{
              padding: '0.75rem 1rem', borderBottom: '1px solid var(--border)',
              backgroundColor: 'var(--bg)'
            }}>
              <h6 style={{ margin: 0, color: 'var(--text-secondary)', fontWeight: '600', fontSize: '0.9rem' }}>
                Uwagi
              </h6>
            </div>
            <div style={{ padding: '1rem' }}>
              <p style={{ margin: 0, fontSize: '0.875rem', color: 'var(--text)' }}>
                {hook.invoice.uwagi}
              </p>
            </div>
          </div>
        )}

        {/* Modals */}
        {hook.showEditModal && hook.editingItem && (
          <EditItemModal
            editingItem={hook.editingItem}
            editFormData={hook.editFormData}
            onFieldChange={hook.handleEditFieldChange}
            onSave={hook.handleSaveEdit}
            onClose={() => hook.setShowEditModal(false)}
          />
        )}

        {hook.showMappingModal && hook.mappingItem && (
          <MappingModal
            mappingItem={hook.mappingItem}
            searchQuery={hook.searchQuery}
            searchResults={hook.searchResults}
            searchLoading={hook.searchLoading}
            selectedProduct={hook.selectedProduct}
            onSearchChange={hook.handleSearchChange}
            onProductSelect={hook.handleProductSelect}
            onClearProduct={() => {
              hook.setSelectedProduct(null);
              hook.setSearchQuery('');
            }}
            onSave={hook.handleSaveMapping}
            onClose={() => hook.setShowMappingModal(false)}
          />
        )}

        <CustomerModal
          isOpen={hook.showAddSupplierModal}
          onClose={() => hook.setShowAddSupplierModal(false)}
          onSuccess={hook.handleNewSupplierAdded}
          initialData={{ typ_klienta: 'firma' }}
        />

        <PurchaseInvoiceCorrectionModal
          isOpen={hook.showCorrectionModal}
          onClose={() => hook.setShowCorrectionModal(false)}
          invoice={hook.invoice}
          onCorrectionComplete={() => {
            hook.loadInvoiceDetails();
          }}
        />
      </div>
    </div>
  );
};

export default PurchaseInvoiceDetailsPage;
